module.exports = __webpack_public_path__ + "img/彩条.7c951178.png";